module.exports = __webpack_public_path__ + "img/coin100.5e3dd936.png";